/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import * as types from '../actions/action-types';

// Keep track of the current language so language updates can trigger state reloads without having to use packages
// like react-i18next. Ideally, this would be done with React Context not Redux, but using the import syntax seems
// to break React Context in our project.

const initialState = {
    language: 'en'
};
function localeReducer(state = initialState, action) {
    return action.type === types.CHANGE_LANGUAGE ? { language: action.language } : state;
}

export default localeReducer;
